// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_keycap_stop_shelf/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_keycap_stop_shelf: ModuleSchema = {
  "id": "core_keycap_stop_shelf",
  "uniqueId": "B3D_KCS01",
  "createdAt": "2026-10-15T07:08:49.087Z",
  "updatedAt": "2026-10-21T15:01:20.157Z",
  "label": "Keycap Stop Shelf",
  "description": "Reusable fixed-standard keycap stop: 7mm travel, 1.2mm ledge, 1.2mm underside bevel and 0.5mm inner lip.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_STOP01",
    "keycap",
    "stop-shelf"
  ],
  "sliders": [
    {
      "key": "displayMode",
      "label": "Display Mode (0:Both, 1:Shelf, 2:Base)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "mm",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerW",
      "label": "Host Width for 40mm Keycap",
      "min": 12,
      "max": 60,
      "default": 44.6,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerD",
      "label": "Host Depth for 40mm Keycap",
      "min": 12,
      "max": 60,
      "default": 44.6,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "hostH",
      "label": "Host Height",
      "min": 8,
      "max": 40,
      "default": 18,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wall",
      "label": "Wall Thickness",
      "min": 0.8,
      "max": 6,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Host Base Color",
      "default": "#0F5E9C",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shelf",
      "label": "Stop Shelf Color",
      "default": "#475569",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
